<template>
  <div class="mc-main-page">
    <div class="mc-main-page__top">
      <search></search>

      <Gender></Gender>
    </div>

    <!-- Loading state -->
    <div v-if="mainPageLoading" class="mc-loader">
      <span class="mc-loader__circle"></span>
    </div>

    <!-- Error state -->
    <div v-else-if="mainPageError" class="mc-error">
      Произошла ошибка при загрузке данных. Пожалуйста, обновите страницу.
    </div>

    <!-- Dynamic blocks rendering -->
    <template v-else-if="mainPageData && mainPageData.length">
      <component
          v-for="(block, index) in mainPageData"
          :key="index"
          :is="getComponentType(block.type)"
          :data="block"
      />
    </template>

    <!-- Fallback when no data -->
    <div v-else class="mc-no-data">
      Нет данных для отображения
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import { Pagination, Navigation, Scrollbar } from 'swiper';
import search from './parts/Search.vue';
import { mapGetters, mapActions } from 'vuex';

// Import components for different block types
import BannerBlock from './blocks/BannerBlock.vue';
import SliderBlock from './blocks/SliderBlock.vue';
import TextBlock from './blocks/TextBlock.vue';
import ProductBlock from './blocks/ProductBlock.vue';
import CollectionBlock from './blocks/CollectionBlock.vue';
import Gender from './blocks/Gender.vue';

export default {
    beforeRouteLeave(to, from) {
        //if (to.name != 'login')
        //  this.$store.dispatch('unLoader');
    },
    created() {
        this.fetchMainPageData();
    },
    computed: {
      ...mapGetters([
        'user',
        'mainPageData',
        'mainPageLoading',
        'mainPageError',
          'gender'
      ])
    },
    async mounted() {
      document.title = 'Главная страница';
    },
    watch: {
      gender(newValue, oldValue) {
        if (oldValue && oldValue != newValue) {
          this.fetchMainPageData({update:true});
        }
      }
    },
    methods: {
      ...mapActions(['fetchMainPageData']),
      // Map block type to component name
      getComponentType(type) {
        const componentMap = {
          'banner': 'banner-block',
          'slider': 'slider-block',
          'text': 'text-block',
          'product': 'product-block',
          'collection': 'collection-block'
        };
        return componentMap[type] || 'div'; // Return div as fallback if type is not recognized
      }
    },
    data: () => ({
      modules: [Navigation, Scrollbar, Pagination],
      exit: false
    }),
    components: {
      Swiper,
      SwiperSlide,
      search,
      BannerBlock,
      SliderBlock,
      TextBlock,
      ProductBlock,
      CollectionBlock,
      Gender
    }
}
</script>
